/* The model's colours under the cards of the collection grid and of the homepage rows (snippets/home-product-card,
   colors: true; styles in assets/home.css).
   Motion of the «Кадр» prototype: hovering a tile flies the viewfinder corners onto it, turns the card's big photo
   into that colour and shows the colour's name on the photo (plus «Під замовлення» when it is out of stock);
   leaving the row puts everything back.
   Delegated on document, so it also covers the cards added by «Показати ще». On touch the tiles are plain links.
   The homepage loads the file once per row of products: only the first copy listens. */
(() => {
  if (window.cardColorsOn) return;
  window.cardColorsOn = true;
  const parts = (strip) => {
    const card = strip.previousElementSibling;
    const media = card && card.querySelector('.hs-card__media');
    if (!media) return null;
    let swap = media.querySelector('.hs-card__swap');
    if (!swap) {
      const main = media.querySelector('img');
      swap = document.createElement('img');
      swap.className = 'hs-card__swap';
      swap.alt = '';
      if (main) swap.sizes = main.sizes;
      const tag = document.createElement('span');
      tag.className = 'hs-card__tag';
      tag.setAttribute('aria-hidden', 'true');
      media.append(swap, tag);
    }
    return { card, swap, tag: media.querySelector('.hs-card__tag') };
  };

  // the other colours' big photos start loading as soon as the pointer reaches the row
  const preload = (strip, sizes) => {
    if (strip.dataset.ready) return;
    strip.dataset.ready = '1';
    strip.querySelectorAll('.hs-colors__item:not(.is-current)[data-srcset]').forEach((tile) => {
      const img = new Image();
      img.sizes = sizes;
      img.srcset = tile.dataset.srcset;
    });
  };

  const show = (tile) => {
    const strip = tile.closest('.hs-colors');
    const p = strip && parts(strip);
    if (!p) return;
    preload(strip, p.swap.sizes);
    focus(strip, tile);

    const own = tile.classList.contains('is-current');
    if (!own && tile.dataset.srcset) p.swap.srcset = tile.dataset.srcset;
    p.card.classList.toggle('is-swap', !own && !!tile.dataset.srcset);

    p.tag.textContent = tile.dataset.label || '';
    if (tile.hasAttribute('data-pre')) {
      const dot = document.createElement('span');
      dot.className = 'hs-dot';
      const pre = document.createElement('span');
      pre.textContent = strip.dataset.pre || '';
      p.tag.append(dot, pre);
    }
    p.card.classList.add('is-tag');
  };

  // the tile in focus (the hovered one, or the card's own at rest) gets the corners and steps up
  const focus = (strip, tile) => {
    strip.querySelectorAll('.hs-colors__item').forEach((t) => t.classList.toggle('is-target', t === tile));
    const mark = strip.querySelector('.hs-colors__mark');
    if (mark && tile) mark.style.setProperty('--at', tile.dataset.n);
  };

  const reset = (strip) => {
    focus(strip, strip.querySelector('.hs-colors__item.is-current'));
    const card = strip.previousElementSibling;
    if (card) card.classList.remove('is-swap', 'is-tag');
  };

  document.addEventListener('pointerover', (e) => {
    if (e.pointerType !== 'mouse') return;
    const tile = e.target.closest && e.target.closest('.hs-colors__item');
    if (tile) show(tile);
  });
  document.addEventListener('pointerout', (e) => {
    const strip = e.target.closest && e.target.closest('.hs-colors');
    if (strip && !strip.contains(e.relatedTarget)) reset(strip);
  });
  document.addEventListener('focusin', (e) => {
    const tile = e.target.closest && e.target.closest('.hs-colors__item');
    if (tile) show(tile);
  });
  document.addEventListener('focusout', (e) => {
    const strip = e.target.closest && e.target.closest('.hs-colors');
    if (strip && !strip.contains(e.relatedTarget)) reset(strip);
  });
})();
